/**
 * ETML
 * @ De: Theo Bensaci
 * @ Date: 13:53 22.04.2023
 * @ Description: class permettant de géré les erreur des phrase
 */



export default class SentenceError{
    constructor(replace,startPos,endPos){
        this.replace=replace;
        this.startPos=startPos;
        this.endPos=endPos;
    }
}